import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { GoogleMapsProvider } from './contexts/GoogleMapsContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MagicLogin from './pages/MagicLogin';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import EvaluateAddress from './pages/EvaluateAddress';
import EvaluationDetail from './pages/EvaluationDetail';
import FindNeighborhood from './pages/FindNeighborhood';
import Training from './pages/Training';
import Settings from './pages/Settings';
import OfferPlayground from './pages/OfferPlayground';
import UserAgreement from './pages/UserAgreement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminRoute from './components/AdminRoute';
import './App.css';

function App() {
  return (
    <GoogleMapsProvider>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="App">
            <Toaster position="top-right" />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Navigate to="/login" replace />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/auth/magic" element={<MagicLogin />} />
              <Route path="/auth/magic/:token" element={<MagicLogin />} />
              <Route path="/user-agreement" element={<UserAgreement />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/evaluate"
                element={
                  <PrivateRoute>
                    <EvaluateAddress />
                  </PrivateRoute>
                }
              />
              <Route
                path="/neighborhood/find"
                element={
                  <PrivateRoute>
                    <FindNeighborhood />
                  </PrivateRoute>
                }
              />
              <Route
                path="/training"
                element={
                  <PrivateRoute>
                    <Training />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/evaluation/:id"
                element={
                  <PrivateRoute>
                    <EvaluationDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/offer-playground/:playgroundId"
                element={
                  <PrivateRoute>
                    <OfferPlayground />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </GoogleMapsProvider>
  );
}

export default App;
